@if (!item.hidden) {
  <!-- collapsible title -->
  @if (!item.url) {
    <a
      class="d-flex align-items-center"
      [ngClass]="item.classes"
      [ngClass]="item.type == 'section' ? 'dropdown-toggle nav-link' : 'dropdown-item dropdown-toggle'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- itemContent template -->
  <ng-template #itemContent>
    @if (item.icon) {
      <span [data-feather]="item.icon"></span>
    }
    <span [translate]="item.translate">{{ item.title }}</span>
  </ng-template>
  <!-- sub-menu item/collapsible -->
  <ul
    class="dropdown-menu"
    [ngClass]="{ show: isShow }">
    @for (item of item.children; track item) {
      <!-- item -->
      @if (item.type == "item" && checkPermission(item)) {
        <li
          core-menu-horizontal-item
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true, 'hide-mobile': !item.aufHandyAnzeigen }"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
          <span
            [routerLink]="item.openInNewTab ? [] : [item.url]"
            class="d-none"></span>
        </li>
      }
      <!-- collapsible -->
      @if (item.type == "collapsible" && checkPermission(item)) {
        <li
          core-menu-horizontal-collapsible
          [item]="item"
          class="dropdown dropdown-submenu"
          [ngClass]="{
            'hide-mobile': !item.aufHandyAnzeigen,
          }"></li>
      }
    }
  </ul>
}
